import GPagination from './GPagination.vue';

export default GPagination;

export { GPagination };
